import { Client } from "@Dao/responseTypes";
import getAPI from "@API/index";

export async function recalculateRisk(clientId: string) {
  await getAPI().request({
    url: `/api/Client/${clientId}/risk-signals/analyze?onlyByDefaultGroup=false`,
    method: "GET",
  });
}

export async function recalculateRiskOncePerWeek(
  clientData: Record<any, any>,
  riskSignalsEnabled: boolean
) {
  await getAPI().request({
    url: `/api/Client`,
    method: "PUT",
    data: {
      ...clientData,
      riskSignalsEnabled,
    },
  });
}

export async function getClientDataById(clientId: string) {
  return await getAPI().request<Client>({
    url: `/api/Client/${clientId}`,
  });
}

export const BigNumberFullFormat = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function isNumber(value: string) {
  return !isNaN(Number(value));
}
